import { isEmpty, findIndex, find } from 'lodash';
import store from '@/store/store';
import CartApis from '@/Components/Controllers/CartApis';

export default {
    namespaced: true,
    state: { 
        id: '',
        cartDetail: {},
        selectedStoreTimeSlots: [],
        cartItems: [],
        cartSubTotal: 0.00,
        cartTax: 0.00,
        promocode: null,
        cartGrandTotal: 0.00,
        cartWeight: 0,
        pendingItem: {},
        successObj: {},
        loyalityPointsObj: {}, 
        loyalityPointsNotice: '',
        loyality: null,
        greenline_pos: {},
        tendy_pos: {},
   
    },
    getters: {
        id: state => state.id ? state.id : (state.cartDetail.id ? state.cartDetail.id : ''),
        cartDetail: state => state.cartDetail,
        selectedStoreTimeSlots: state => state.selectedStoreTimeSlots,
        cartItems: state => state.cartItems,
        cartItemsIds(state) {
          let pids = state.cartItems.map( function(obj) { return obj.product_id; } );
          return [...new Set(pids)]; // make unique
        },
        cartEveryItemCount(state) {
          let totalItems = 0;
          state.cartItems.map(item => {
            totalItems += item.unit;
          })
          return totalItems;
        },
        cartSubTotal(state) {
            let subTotal = 0;
            let is_tendy_pos = store.getters['location/is_tendy_pos'];
            if(is_tendy_pos) {
              if(_.isEmpty(state.tendy_pos)){
                return 0;
              }
              return (Math.round(state.tendy_pos.subtotal * 100) / 100).toFixed(2);
            }

            state.cartItems.map(item => {
                subTotal += item.unit * item.price;
            })
            subTotal = (Math.round(subTotal * 100) / 100).toFixed(2);
            state.cartSubTotal = subTotal;
            return subTotal;
        },

        // this is visable if promocode active
        newSubTotal(state){
           // Check for greenline pos
           let is_greenline_pos = store.getters['location/is_greenline_pos'];
           let is_tendy_pos = store.getters['location/is_tendy_pos'];

           if(is_greenline_pos){
             
              let greenlineTotal = store.getters['cart/greenline_pos_total'];
              if(state.promocode && state.promocode.applied_value){
                greenlineTotal = parseFloat(parseFloat(greenlineTotal) - parseFloat(state.promocode.applied_value) ) 
              } 
              return greenlineTotal;
            

           } else if (is_tendy_pos) {
      
              let tendySubTotal = state.tendy_pos.subtotal
              if(state.promocode && state.promocode.applied_value){
                tendySubTotal = parseFloat(parseFloat(tendySubTotal) - parseFloat(state.promocode.applied_value) ) 
              } 
              return (Math.round(tendySubTotal * 100) / 100).toFixed(2);
           }
   
           let newSubtotal = parseFloat(state.cartSubTotal);
           // If promocode then decrease 
           if(state.promocode && state.promocode.applied_value){
             newSubtotal = parseFloat(parseFloat(newSubtotal) - parseFloat(state.promocode.applied_value) ) 
           } 
           // If loyality then decrease
           if(state.loyality && state.loyality.redeem_amount){
             newSubtotal = parseFloat( parseFloat(newSubtotal) - parseFloat(state.loyality.redeem_amount) ) 
           }
           // If cart tax then decrease
          return (Math.round(newSubtotal * 100) / 100).toFixed(2);
          //  return newSubtotal.toFixed(2);
        },
        
        cartTax(state) {
          
          // Check for greenline pos
          let is_greenline_pos = store.getters['location/is_greenline_pos'];
          let is_tendy_pos = store.getters['location/is_tendy_pos'];

          if(is_greenline_pos){
            return store.getters['cart/greenline_pos_tax'];

          } else if(is_tendy_pos) {
            return store.getters['cart/tendy_pos_tax'];
          }
         
          let selectedLocation = store.getters['location/selected'];
          if (!_.isEmpty(selectedLocation) && selectedLocation.settings && selectedLocation.settings.tax_settings) {
            if(selectedLocation.settings.tax_settings.price_includes_tax){
              state.cartTax = 0;
              return 0;
            }
            if (selectedLocation.settings.tax_settings.price_includes_tax == false) {
                // taxable amount, if promocode is added then need to decrease price from subtotal
                let cartTax = 0;

                let subtotal_after_deducation = state.cartSubTotal;
                // for promocode deduction, lets not calculte promocode
                if(state.promocode && state.promocode.applied_value){
                  subtotal_after_deducation = subtotal_after_deducation - state.promocode.applied_value;
                }
                // loyalty is decrease after added tax so lets not include on tax
                if(state.loyality && state.loyality.redeem_amount){
                  subtotal_after_deducation = subtotal_after_deducation - state.loyality.redeem_amount;
                }
                cartTax = ((subtotal_after_deducation * parseFloat(selectedLocation.settings.tax_settings.tax)) / 100);
                cartTax = (Math.round(cartTax * 100) / 100).toFixed(2);
                state.cartTax = cartTax;
                return cartTax;

            } else {
                state.cartTax = 0;
            }
          }
          return 0;
        },

        cartGrandTotal(state) {

          // Check for greenline pos
          let is_greenline_pos = store.getters['location/is_greenline_pos'];
          let is_tendy_pos = store.getters['location/is_tendy_pos'];
          if(is_greenline_pos){
           
            let greenlineTotal = parseFloat(store.getters['cart/greenline_pos_total']);
             // If loyalty decrease , remove again
            // if(state.loyality && state.loyality.redeem_amount){
            //   greenlineTotal = parseFloat( parseFloat(greenlineTotal) - parseFloat(state.loyality.redeem_amount) ) 
            // }// on gren line tip delivery is calculated from backend
            return (Math.round(greenlineTotal * 100) / 100).toFixed(2);
            // return greenlineTotal.toFixed(2);
          } else if (is_tendy_pos) {
            let tendy_total = parseFloat(store.getters['cart/tendy_pos_total']);
            return (Math.round(tendy_total * 100) / 100).toFixed(2);
          }
  
          let grandTotal = parseFloat(state.cartSubTotal);
          // If promocode then decrease 
          if(state.promocode && state.promocode.applied_value){
            grandTotal = parseFloat(parseFloat(grandTotal) - parseFloat(state.promocode.applied_value) ) 
          } 
          
          // If cart tax then decrease

          if(state.cartTax){
            grandTotal = parseFloat( parseFloat(grandTotal) + parseFloat(state.cartTax) ) 
          }

          // If loyality then decrease, loyalty shoud decrease on tax addded price
          if(state.loyality && state.loyality.redeem_amount){
            grandTotal = parseFloat( parseFloat(grandTotal) - parseFloat(state.loyality.redeem_amount) ) 
          }
          return (Math.round(grandTotal * 100) / 100).toFixed(2);
         // return grandTotal.toFixed(2);
        },

        cartWeight(state) {
            let weight = 0;
            state.cartItems.map(item => {
              weight += parseFloat(item.unit) * parseFloat(item.weight);
            })
            let totalWeight = weight.toFixed(2);
            state.cartWeight = totalWeight
            return totalWeight;
        },
        
        promocode(state) {
          let promocodedata = (state.cartDetail.cart_promocodes) && (state.cartDetail.cart_promocodes.length > 0) ? state.cartDetail.cart_promocodes[0] : null;
          state.promocode = promocodedata
          return promocodedata;
        },

        loyality(state) {
          let loyality = state.cartDetail.cart_loyalty ? state.cartDetail.cart_loyalty : null;
          state.loyality = loyality;
          return loyality;
        },

        pendingItem: state => state.pendingItem,
        successObj: state => state.successObj,
        loyalityPointsObj: state => state.loyalityPointsObj,
        loyalityPointsNotice: state => state.loyalityPointsNotice,
        // Greenline pos
        greenline_pos: state => state.greenline_pos,
        greenline_pos_total(state){
          if(_.isEmpty(state.greenline_pos)){
            return 0;
          }
          let posTotal = (state.greenline_pos.total/100);
          return (Math.round(posTotal * 100) / 100).toFixed(2);
          // return (state.greenline_pos.total/100).toFixed(2);
        },
        greenline_product_deposit(state) {
          if(_.isEmpty(state.greenline_pos)){
            return 0;
          }
          if(state.greenline_pos.products && (state.greenline_pos.products.length > 0) ){
            let deposit = 0;
            state.greenline_pos.products.forEach(item => {
              deposit += item.depositFee;
            })
            deposit = (deposit/100);
            return (Math.round(deposit * 100) / 100).toFixed(2);
          } else {
            return 0;
          }
        },
        greenline_pos_tax(state){
          if(_.isEmpty(state.greenline_pos)){
            return 0;
          }
          if(state.greenline_pos.products && (state.greenline_pos.products.length > 0) ){
            let taxAmount = 0;
            state.greenline_pos.products.forEach(item => {
              let taxes = item.taxes;
               if(taxes && taxes.length > 0){
                taxes.forEach(taxitem => {
                  taxAmount += taxitem.amount;
                })
               }
            })
            taxAmount = (taxAmount/100);
            return (Math.round(taxAmount * 100) / 100).toFixed(2);
          } else {
            return 0;
          }
        },
        // Tendy Pos
        tendy_pos: state => state.tendy_pos,
        tendy_pos_total(state){
          if(_.isEmpty(state.tendy_pos)){
            return 0;
          }
          return (Math.round(state.tendy_pos.total * 100) / 100).toFixed(2);
        },
        tendy_pos_tax(state){
          if(_.isEmpty(state.tendy_pos)){
            return 0;
          }
          return state.tendy_pos.tax ? (Math.round(state.tendy_pos.tax * 100) / 100).toFixed(2) : 0;
        },
    },
    mutations: {
        idMutate(state, data) {
            state.id = data;
        },
        cartDetailMutate(state, data) {
            state.cartDetail = data;
        },
        setCartItemsMutate(state, data) {
            state.cartItems = data;
        },
        selectedStoreTimeSlotsMutate(state, data) {
            state.selectedStoreTimeSlots = data;
        },
        pendingItemMutate(state, data) {
          state.pendingItem = data;
        },
        clearCartMutate(state) {
          state = { 
            id: '',
            cartDetail: {},
            selectedStoreTimeSlots: [],
            cartItems: [],
            cartSubTotal: 0.00,
            cartTax: 0.00,
            cartGrandTotal: 0.00,
            cartWeight: 0,
            pendingItem: {},
          };
        },
        successObjMutate(state, data) {
          state.successObj = data;
        },
        loyalityPointsObjMutate(state, data) {
          state.loyalityPointsObj = data;
        },
        loyalityPointsNoticeMutate(state, data) {
          state.loyalityPointsNotice = data;
        },
        greenLinePosMutate(state, data) {
          state.greenline_pos = data;
        },
        tendyPosMutate(state, data) {
          state.tendy_pos = data;
        },
    },
    actions: {
        setId(context, data) {
            context.commit('idMutate', data);
        },
        setCartDetail(context, data) {
            context.commit('cartDetailMutate', data);
        },
        setSelectedStoreTimeSlots(context, data) {
            context.commit('selectedStoreTimeSlotsMutate', data);
        },
        setCartItems(context, data) {
            context.commit('setCartItemsMutate', data);
        },
        setPendingItem(context, data) {
          context.commit('pendingItemMutate', data);
        },
        setSuccessObj(context, data) {
          context.commit('successObjMutate', data);
        },
        clearCart(context){
          context.commit('clearCartMutate');
        },
        async setLoyalityPointsObj(context, objData){
          let businessLoyalty = store.getters['businessprofile/businessLoyality'];
          let in_store = store.getters['getInStore'];
       
          let orderReceivedMethod = 'pickup'; // by default
          if(objData.order_receive_method == 'pickup' && in_store){
            orderReceivedMethod = 'instore';
          } else if (objData.order_receive_method == 'delivery') {
            orderReceivedMethod = 'delivery';
          }

          if(businessLoyalty.id && context.getters.id && businessLoyalty.is_active) {
            let res = await CartApis.getCartLoyalityPointOverview(context.getters.id, orderReceivedMethod);
            //If the preview status is 500 we receive some informations catch that info
            if(res.response && res.response.status == 500){
              let msg = (res.response.data && res.response.data.msg) ? res.response.data.msg : '';
              context.commit('loyalityPointsNoticeMutate', msg );
            } else {
              context.commit('loyalityPointsNoticeMutate', '');
            }
            // Loyalty data
            if(res && (res.status == 200) ){
              context.commit('loyalityPointsObjMutate', res.data.payload);
            } else {
              context.commit('loyalityPointsObjMutate', {});
            }
          } else {
            context.commit('loyalityPointsObjMutate', {});
          }
        },  
        async setGreenLinePosData(context, data){
          if(context.getters.id){
            let res = await CartApis.prevalidateWithGreenline(context.getters.id, data);
            if(res.status == 200){
              context.commit('greenLinePosMutate', res.data.payload);
            } else {
              context.commit('greenLinePosMutate', {});
            }
          }
        }, 
        
        async setTendyPosData(context, data){
          if(context.getters.id){
            let res = await CartApis.prevalidateWithTendy(context.getters.id, data);
            if(res.status == 200){
              context.commit('tendyPosMutate', res.data.payload);
            } else {
              context.commit('tendyPosMutate', {});
            }
          }
        }, 
    },
};